import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Form, Alert, InputGroup, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

function Account() {
    const userx = useSelector(state => state.user);
    const [user, setUser] = useState({})

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formaLoading, setFormLoading] = useState(false);
    const [qrimg, setQrimg] = useState("");
    const [code, setCode] = useState("");
    const [tfaFormLoading, setTfaFormLoading] = useState(false);
    const [tfaFormMessage, setTfaFormMessage] = useState({
        variant: null,
        message: null
    })
    const [tfaFormValidation, setTTFormValidation] = useState({
        code : false
    })

    useEffect(() => {
        var usery = Object.assign({}, userx)
        if (userx.Logged) {
            setUser(usery.User)
        }
    }, [user]);

    const EnableTFA = async () => {
        if(code == "") {
            setTTFormValidation({
                code : true
            })
            return ;
        }
        setTTFormValidation({
            code : false
        })

        setTfaFormLoading(true);

        const response = await axios.post(window.__CFG.API + "manager/Enable2FA", {
            token : code
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            const userResponse = await axios.get(window.__CFG.API + "manager/GetUser", {
                headers: {
                  "Authorization": "Bearer " + localStorage.getItem("raff-token")
                }
            })

            setTfaFormLoading(false);

            if (userResponse.data.Error == null) {
                dispatch({
                  type: "SET_USER",
                  data: {
                    logged: true,
                    user: userResponse.data.User,
                  }
                })
                navigate("/affiliate/account-settings");
            }
        } else {
            setTfaFormLoading(false);
            setTfaFormMessage({
                variant : "danger",
                message : response.data.Error
            })
        }
    }

    const Load2FA = async () => {
        setFormLoading(true);

        const response = await axios.post(window.__CFG.API + "manager/Load2FA", {}, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        setFormLoading(false);

        if(response.data.Error == null) {
            setQrimg(response.data.QRCode);
        }
    }

    useEffect(() => {
        Load2FA();
    }, [])

    return (
        <Container>
            <Row>
                <Col>
                    <h4 className="text-start fw-bold mt-5">Enable Two-Factor Authentication</h4>
                    <div className='mt-3' style={{ lineHeight: "1" }} >
                        <div className="tfa-steps">
                            <ol>
                                <li>
                                    <h6>Add account to Google Authenticator Application</h6>
                                    <p>Download Google Authentication App ( <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en" target="_blank">Android</a> / <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">IOS</a> ), then add your account by scanning the QR code below.</p>
                                </li>
                                <li>
                                    <h6>Enter a 6-digit Google Authenticator code</h6>
                                    <p>Ensure that your account has been added to Google Authenticator correctly by entering the 6-digit code generated by Google Authenticator below. Then click “Enable”.</p>
                                </li>
                            </ol>

                            <div className="tfa-qr-img">
                                <img src={qrimg}></img>
                            </div>

                            <div className="tfa-form">
                                {
                                    tfaFormMessage.variant != null ? (
                                        <Alert variant={tfaFormMessage.variant} dismissible>{tfaFormMessage.message}</Alert>
                                    ) : (
                                        <></>
                                    )
                                }

                                <InputGroup>
                                    <InputGroup.Text><i className="fas fa-lock"></i></InputGroup.Text>
                                    <Form.Control value={code} onChange={e => setCode(e.target.value)} isInvalid={tfaFormValidation.code} placeholder="Code"></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Field should be filled in
                                    </Form.Control.Feedback>
                                </InputGroup>

                                <div className="tfa-form-btn">
                                    <Button onClick={EnableTFA} type="button" className="rounded-pill text-light bg-warning py-2 my-4 cursor-pointer w-full border-0 account-save-button">
                                        {tfaFormLoading ? <Spinner size="sm" /> : "Enable"}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Account